import { IconProp } from '@fortawesome/fontawesome-svg-core';
import i18n from 'i18next';
import { RiskEvaluationColor, RiskReviewStatusType, RiskStatusType } from 'types/graphql-global-types';

export const mapRiskStatus = (status: RiskStatusType) => {
    switch (status) {
        case RiskStatusType.DRAFT:
            return i18n.t('ra:DRAFT');
        case RiskStatusType.ASSESSED:
            return i18n.t('ra:ASSESSED');
        case RiskStatusType.CLOSED:
            return i18n.t('ra:CLOSED');
        case RiskStatusType.CONTROLLED:
            return i18n.t('ra:CONTROLLED');
        case RiskStatusType.IDENTIFIED:
            return i18n.t('ra:IDENTIFIED');
        case RiskStatusType.NOT_APPLICABLE:
            return i18n.t('ra:NOT_APPLICABLE');
        case RiskStatusType.TRIGGERED:
            return i18n.t('ra:TRIGGERED');
        case RiskStatusType.OBSOLETE:
            return i18n.t('ra:OBSOLETE');
        default:
            return '';
    }
};

export const mapRiskReviewStatus = (status: RiskReviewStatusType) => {
    switch (status) {
        case RiskReviewStatusType.NOT_REVIEWED:
            return i18n.t('ram:risks:riskReviewStatus:NOT_REVIEWED');
        case RiskReviewStatusType.REVIEWED:
            return i18n.t('ram:risks:riskReviewStatus:REVIEWED');
        case RiskReviewStatusType.REVIEW_DUE:
            return i18n.t('ram:risks:riskReviewStatus:REVIEW_DUE');
        case RiskReviewStatusType.REVIEW_OVERDUE:
            return i18n.t('ram:risks:riskReviewStatus:REVIEW_OVERDUE');
        case RiskReviewStatusType.REVIEW_NOT_REQUIRED:
            return i18n.t('ram:risks:riskReviewStatus:REVIEW_NOT_REQUIRED');
        case RiskReviewStatusType.NOT_APPLICABLE:
            return i18n.t('ram:risks:riskReviewStatus:NOT_APPLICABLE');
        default:
            return '';
    }
};

export const mapRiskReviewStatusIcon: (status?: RiskReviewStatusType | null) => {
    icon: IconProp;
    color: string | undefined;
} = (status?: RiskReviewStatusType | null) => {
    switch (status) {
        case i18n.t('ram:risks:riskReviewStatus:NOT_REVIEWED'):
            return { icon: ['fas', 'exclamation-triangle'], color: 'grey' };
        case i18n.t('ram:risks:riskReviewStatus:REVIEWED'):
            return { icon: ['fas', 'circle-check'], color: 'green' };
        case i18n.t('ram:risks:riskReviewStatus:REVIEW_DUE'):
            return { icon: ['fas', 'exclamation-triangle'], color: 'primary' };
        case i18n.t('ram:risks:riskReviewStatus:REVIEW_OVERDUE'):
            return { icon: ['fas', 'exclamation-triangle'], color: 'secondary' };
        case i18n.t('ram:risks:riskReviewStatus:REVIEW_NOT_REQUIRED'):
            return { icon: ['fas', 'exclamation-triangle'], color: undefined };
        default:
            return { icon: ['fas', 'exclamation-triangle'], color: undefined };
    }
};

export const convertRiskScoreColorToWeight = (color: RiskEvaluationColor) => {
    const convertedColour = color !== undefined ? color.toUpperCase() : color;

    switch (convertedColour as RiskEvaluationColor) {
        case RiskEvaluationColor.RED:
            return 4;
        case RiskEvaluationColor.AMBER:
            return 3;
        case RiskEvaluationColor.GREEN:
            return 2;
        case RiskEvaluationColor.NONE:
            return 1;
        default:
            return 0;
    }
};

export const RiskStatuses = () => {
    return Object.values(RiskStatusType).map((status: RiskStatusType) => {
        return mapRiskStatus(status);
    });
};

export const RiskReviewStatuses = () => {
    return Object.values(RiskReviewStatusType).map((status: RiskReviewStatusType) => {
        return mapRiskReviewStatus(status);
    });
};

export const RiskReviewStatusesForFilter = () => {
    return Object.values(RiskReviewStatusType)
        .filter((status) => status !== RiskReviewStatusType.REVIEW_NOT_REQUIRED)
        .map((status: RiskReviewStatusType) => {
            return mapRiskReviewStatus(status);
        });
};
